import { TemaOrientador } from "./types";

export interface OpcionMomento {
  slug: string | null;
  label: string;
}

export const OPCIONES_MOMENTO: OpcionMomento[] = [
  { slug: "vida-independiente", label: "Vida independiente" },
  { slug: "vida-en-pareja", label: "Vida en pareja" },
  { slug: "hijos-y-crianza", label: "Hijos y crianza" },
  { slug: "vivienda-y-patrimonio", label: "Vivienda y patrimonio" },
  { slug: "trabajo-y-negocio", label: "Trabajo y negocio" },
  { slug: "cambios-de-vida", label: "Cambios de vida" },
  { slug: "cuidados-y-autonomia", label: "Cuidados y autonomía" },
  { slug: "legado-y-sucesion", label: "Legado y sucesión" },
  { slug: null, label: "No lo tengo claro" },
];

export const OPCIONES_URGENCIA = [
  {
    id: "fecha",
    label: "Sí, hay una fecha o notificación encima de la mesa",
    siguiente: "prioritaria" as const,
  },
  {
    id: "pronto",
    label: "Puede haber consecuencias pronto",
    siguiente: "prioritaria" as const,
  },
  {
    id: "prevenir",
    label: "No, es para prevenir o planear",
    siguiente: "normal" as const,
  },
];

const T: TemaOrientador[] = [
  {
    id: "renta-contrato",
    label: "Renta, contrato o algo que firmé",
    servicio: "bienes-y-patrimonio",
    docs: ["El contrato que firmaste", "Comprobantes de pago", "Fotos o inventario del inmueble", "Mensajes con la otra parte"],
  },
  {
    id: "compra-fallo",
    label: "Una compra o servicio que falló",
    servicio: "proteccion-del-consumidor",
    docs: ["Comprobante de pago", "Confirmación de la compra o contrato", "Capturas de la publicación o promesa", "Mensajes con el vendedor o proveedor"],
  },
  {
    id: "cobro-indebido",
    label: "Un cobro que no reconozco",
    servicio: "proteccion-del-consumidor",
    docs: ["Estado de cuenta con el cargo", "Comprobante de la relación con el proveedor", "Mensajes o correos del proveedor"],
  },
  {
    id: "datos-fraude",
    label: "Fraude, suplantación o mis datos",
    servicio: "proteccion-digital",
    docs: ["Capturas con fecha y URL visible", "Números de cuenta o folios implicados", "Reportes ya hechos (banco, plataforma, autoridad)"],
  },
  {
    id: "acoso-linea",
    label: "Acoso o contenido difundido sin permiso",
    servicio: "proteccion-digital",
    docs: ["Enlaces o capturas del contenido", "Fechas de publicación", "Identificación de la cuenta o persona"],
  },
  {
    id: "trabajo-despido",
    label: "Despido, renuncia o liquidación",
    servicio: "defensa-laboral",
    docs: ["Contrato de trabajo", "Últimos comprobantes de pago", "Cartas o mensajes del empleador", "Fechas y testigos de lo ocurrido"],
  },
  {
    id: "trabajo-adeudo",
    label: "Adeudo de sueldo o prestaciones",
    servicio: "defensa-laboral",
    docs: ["Comprobantes de pago pendientes", "Contrato o condiciones pactadas", "Registros de horas o funciones"],
  },
  {
    id: "pareja-acuerdos",
    label: "Acuerdos de pareja o matrimonio",
    servicio: "familia-y-acuerdos",
    docs: ["Acta de matrimonio o constancia de unión, si aplica", "Lista de bienes comprados juntos", "Aportaciones de cada quien"],
  },
  {
    id: "separacion",
    label: "Separación o divorcio",
    servicio: "familia-y-acuerdos",
    docs: ["Acta de matrimonio o de nacimiento de hijas e hijos", "Información de cuentas y deudas conjuntas", "Fechas clave de la relación"],
  },
  {
    id: "custodia-pension",
    label: "Custodia, convivencia o pensión",
    servicio: "familia-y-acuerdos",
    docs: ["Actas de nacimiento", "Comprobantes de gastos de las y los menores", "Propuesta realista de convivencia"],
  },
  {
    id: "casa-compraventa",
    label: "Comprar o vender una casa",
    servicio: "bienes-y-patrimonio",
    docs: ["Escrituras o documentos de propiedad", "Boleta predial y agua", "Identificaciones de las partes", "Antecedentes de la operación"],
  },
  {
    id: "casa-problema",
    label: "Problema con mi propiedad o escrituras",
    servicio: "bienes-y-patrimonio",
    docs: ["Escrituras y documentos de la propiedad", "Pagos de predial y servicios", "Cualquier aviso o notificación recibida"],
  },
  {
    id: "herencia",
    label: "Herencia o sucesión",
    servicio: "bienes-y-patrimonio",
    docs: ["Acta de defunción", "Documentos de los bienes (escrituras, cuentas)", "Identificaciones de los familiares", "Testamento, si existe"],
  },
  {
    id: "testamento",
    label: "Quiero hacer testamento",
    servicio: "bienes-y-patrimonio",
    docs: ["Lista de bienes y cuentas", "Identificaciones de beneficiarios", "Actas de nacimiento de familiares"],
  },
  {
    id: "negocio-formal",
    label: "Formalizar o organizar mi negocio",
    servicio: "asesoria-de-negocios",
    docs: ["Descripción de la actividad", "Contratos con clientes o proveedores", "Situación fiscal actual"],
  },
  {
    id: "negocio-socios",
    label: "Acuerdos entre socios",
    servicio: "asesoria-de-negocios",
    docs: ["Documentos de la empresa (acta, RFC)", "Aportaciones de cada socio", "Acuerdos existentes, aunque sean de palabra, anotados"],
  },
  {
    id: "negocio-contratos",
    label: "Contratos con clientes o proveedores",
    servicio: "asesoria-de-negocios",
    docs: ["El contrato o borrador", "Mensajes y correos de la negociación", "Pagos o facturas relacionados"],
  },
  {
    id: "seguro-siniestro",
    label: "Un seguro que no responde",
    servicio: "seguros-y-siniestros",
    docs: ["Póliza y condiciones", "Denuncia o aviso de siniestro", "Correspondencia con la aseguradora", "Presupuestos o facturas del daño"],
  },
  {
    id: "cuidados-mayores",
    label: "Cuidado de personas mayores",
    servicio: "familia-y-acuerdos",
    docs: ["Identificación y documentos de la persona", "Información médica relevante", "Gastos y quién los cubre"],
  },
  {
    id: "representacion",
    label: "Representar a alguien que ya no puede",
    servicio: "familia-y-acuerdos",
    docs: ["Documentos de identidad de la persona", "Diagnóstico médico, si aplica", "Documentos de bienes e ingresos"],
  },
  {
    id: "deudas-reordenar",
    label: "Deudas o gastos por reordenar",
    servicio: "bienes-y-patrimonio",
    docs: ["Estados de cuenta", "Contratos de crédito", "Ingresos y egresos mensuales aproximados"],
  },
];

export const TEMAS_POR_MOMENTO: Record<string, TemaOrientador[]> = {
  "vida-independiente": [T[0], T[1], T[2], T[5], T[6], T[3]],
  "vida-en-pareja": [T[7], T[8], T[10], T[19]],
  "hijos-y-crianza": [T[9], T[8], T[4], T[3]],
  "vivienda-y-patrimonio": [T[10], T[11], T[0], T[17], T[12]],
  "trabajo-y-negocio": [T[14], T[15], T[16], T[5], T[6]],
  "cambios-de-vida": [T[8], T[19], T[12], T[17], T[18]],
  "cuidados-y-autonomia": [T[18], T[19], T[9]],
  "legado-y-sucesion": [T[12], T[13], T[11]],
};

export const TEMAS_GENERALES: TemaOrientador[] = [
  T[10], T[8], T[5], T[14], T[1], T[17], T[3], T[12],
];

export interface ResultadoOrientador {
  areaPrincipalId: string;
  relacionados: string[];
  docs: string[];
  urgente: boolean;
  textoSiguiente: string;
}

export function calcularResultado(
  momentoSlug: string | null,
  temasSeleccionados: TemaOrientador[],
  urgenciaId: string | null
): ResultadoOrientador {
  const conteo = new Map<string, number>();
  temasSeleccionados.forEach((t) => conteo.set(t.servicio, (conteo.get(t.servicio) || 0) + 1));
  let areaPrincipalId = "";
  let max = 0;
  conteo.forEach((v, k) => {
    if (v > max) {
      max = v;
      areaPrincipalId = k;
    }
  });
  if (!areaPrincipalId) areaPrincipalId = temasSeleccionados[0]?.servicio || "bienes-y-patrimonio";
  const relacionados = [...conteo.keys()].filter((k) => k !== areaPrincipalId);

  const docs = Array.from(new Set(temasSeleccionados.flatMap((t) => t.docs)));
  const opcion = OPCIONES_URGENCIA.find((o) => o.id === urgenciaId);
  const urgente = opcion?.siguiente === "prioritaria";

  const textoSiguiente = urgente
    ? "Como hay fecha o riesgo próximo, te recomendamos entrar por atención prioritaria y contarnos la fecha exacta."
    : "Cuéntanos tu situación por el formulario. Te contactamos en horario hábil para agendar la llamada de disponibilidad (15–20 min, sin costo).";

  return {
    areaPrincipalId,
    relacionados,
    docs,
    urgente,
    textoSiguiente,
  };
}
